import React from "react";
import { Container, Span } from "./spinner-styles";
export const Spinner = () => (
  <Container>
    <Span />
  </Container>
);
